import React from 'react';
import { withProps, compose } from 'recompose';
import { Card, CardBody, CardMedia, CardActions, CardName, CardInfoBlock } from '../../common/Card';
import JoinButton from '../../common/JoinButton';
import MoreDetailsButton from '../../common/MoreDetailsButton';
import StartStatusBadge from '../../common/StartStatusBadge';
import { registrationStatuses } from '../../constants';
import withRaceCountDown from '../../common/CountDown/withRaceCountDown';
import withCardInfoItems from './withCardInfoItems';
import style from './index.scss';

export const RaceCountDown = compose(
    withRaceCountDown,
    withProps(
        ({ isHighlighted }) => ({
            classNames: {
                value: isHighlighted && style.highlighted
            }
        })
    )
)(CardInfoBlock);

export const SlideCard = ({
    cardImage,
    name,
    className = '',
    status,
    registrationStatus,
    leaderboardId,
    joined,
    isHorizontal,
    itemRef,
    cardInfoItems
}) => (
        <div className={`${style.container} ${isHorizontal ? style.horizontal : ''}`}>
            <Card
                cardRef={itemRef}
                className={`${style.card} ${className}`}>
                <CardMedia className={style.media} image={cardImage}>
                    <StartStatusBadge status={status} className={style.statusBadge} />
                </CardMedia>
                <CardBody className={style.body}>
                    <CardName className={style.name} name={name} />
                    <div className={style.info}>
                        {cardInfoItems.map(({ breakLine, countDown, ...item }, idx) =>
                            breakLine
                                ? <div key={idx} className={style.breakLine} />
                                : countDown
                                    ? <RaceCountDown
                                        key={idx}
                                        className={style.infoItem}
                                        status={status}
                                        {...countDown}
                                    />
                                    : <CardInfoBlock key={idx} className={style.infoItem} {...item} />
                        )}
                    </div>
                    <CardActions className={style.actions}>
                        <MoreDetailsButton leaderboardId={leaderboardId} />
                        <JoinButton {...{ leaderboardId, joined, registrationStatus }} />
                    </CardActions>
                </CardBody>
            </Card>
        </div>
    );

export default compose(
    withProps(
        ({ smallSizeImage, mediumSizeImage, bannerUrl, isHorizontal, registrationStatus }) => ({
            cardImage: isHorizontal ? bannerUrl : smallSizeImage || mediumSizeImage || bannerUrl,
            displayRegStatus: registrationStatus !== registrationStatuses.INTERNAL
        })
    ),
    withCardInfoItems
)(SlideCard);
